<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <label>Description</label>
      <textarea type="text" class="form-control" formControlName="description"></textarea>
    </div>
    <div class="alert alert-warning" role="alert" *ngIf="!form.valid && (form.controls['description'].dirty || form.controls['description'].touched)">
      <div *ngIf="form.controls['description'].errors.required">
        Please enter description
      </div>
      <div *ngIf="form.controls['description'].errors.maxlength">
        Description cannot be longer than {{ form.controls['description'].errors.maxlength.requiredLength }} characters
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
